<div class="form-group col-md-12 col-xs-12 margin-bottom-5px" *ngIf=" (mode !== 'view' && mode !== 'view2') || mode=='mode'">
  <div class="row row-for-levels" *ngIf="field">
    <div class="col-md-3 text-align-left label-padding-left-10px">
      <label for="firstName" class="margin-bottom-0px margin-top-5px label-color"> {{field.Title}}</label>
    </div>
    <div class="col-md-1 padding-left-0px padding-right-0px text-align-center label-padding-top-2px">
      <input type="checkbox" class="width-18px background-2" [(ngModel)]="isChecked" [ngModelOptions]="{standalone: true}">
    </div>
  </div>

  <div class="row" *ngIf="isChecked && Data && Data.HasChildren">
    <auto-gen-children class="col-12" [Data]="Data" [field]="Data.Data" [mode]="mode"></auto-gen-children>
  </div>
</div>

<div class="form-group col-md-12 col-xs-12 margin-bottom-5px" *ngIf="mode=='view'">
  <div class="row row-for-levels" *ngIf="field">
    <div class="col-md-4 text-align-left label-padding-left-10px">
      <label for="firstName" class="margin-bottom-0px margin-top-5px label-color"> {{field.Title}}</label>
    </div>
    <div class="col-md-6 padding-left-0px label-padding-top-2px">
      <i class="fas fa-check-circle text-success font-size-14px" *ngIf="isTrue"></i>
      <label class="margin-bottom-0px margin-top-5px font-weight-normal" *ngIf="!isTrue && field.Value">: {{field.Value}}</label>
      <label class="margin-bottom-0px margin-top-5px font-weight-normal margin-left-10px" *ngIf="field.Remarks"><i>(Comments: {{field.Remarks}})</i></label>
    </div>
  </div>

  <div class="row" *ngIf="isTrue && Data && Data.HasChildren">
    <auto-gen-children class="col-12" [Data]="Data" [field]="Data.Data" [mode]="mode"></auto-gen-children>
  </div>
</div>

<div class="form-group col-md-12 col-xs-12 margin-bottom-5px" *ngIf="mode=='view2'">
  <div class="row row-for-levels font-size-14" *ngIf="field">
    <div class="col-md-5 text-align-left label-padding-left-10px">
      <label for="firstName" class="margin-bottom-0px margin-top-5px label-color"> {{field.Title}}</label>
    </div>
    <div class="col-md-5 padding-left-0px label-padding-top-2px">
      <i class="fas fa-check-circle text-success font-size-14px" *ngIf="isTrue"></i>
      <label class="margin-bottom-0px margin-top-5px font-weight-normal" *ngIf="!isTrue && field.Value">: {{field.Value}}</label>
      <label class="margin-bottom-0px margin-top-5px font-weight-normal margin-left-10px" *ngIf="field.Remarks"><i>(Comments: {{field.Remarks}})</i></label>
    </div>
  </div>

  <div class="row" *ngIf="isTrue && Data && Data.HasChildren">
    <auto-gen-children class="col-12" [Data]="Data" [field]="Data.Data" [mode]="mode"></auto-gen-children>
  </div>
</div>
